export default __webpack_public_path__ + "static/media/one-bg.b52a2350.png";